import * as types from '../constants/actionTypes';

// Fetch All Udhyam Categories
export const fetchUdhyamCategoriesRequest = (filters = {}) => ({
  type: types.FETCH_UDHYAM_CATEGORIES_REQUEST,
  payload: { filters }
});

export const fetchUdhyamCategoriesSuccess = (categories, totalCount) => ({
  type: types.FETCH_UDHYAM_CATEGORIES_SUCCESS,
  payload: { categories, totalCount }
});

export const fetchUdhyamCategoriesFailure = (error) => ({
  type: types.FETCH_UDHYAM_CATEGORIES_FAILURE,
  payload: { error }
});

// Fetch Active Udhyam Categories
export const fetchActiveUdhyamCategoriesRequest = () => ({
  type: types.FETCH_ACTIVE_UDHYAM_CATEGORIES_REQUEST
});

export const fetchActiveUdhyamCategoriesSuccess = (categories, totalCount) => ({
  type: types.FETCH_ACTIVE_UDHYAM_CATEGORIES_SUCCESS,
  payload: { categories, totalCount }
});

export const fetchActiveUdhyamCategoriesFailure = (error) => ({
  type: types.FETCH_ACTIVE_UDHYAM_CATEGORIES_FAILURE,
  payload: { error }
});

// Get Udhyam Category by ID
export const getUdhyamCategoryRequest = (id) => ({
  type: types.GET_UDHYAM_CATEGORY_REQUEST,
  payload: { id }
});

export const getUdhyamCategorySuccess = (category) => ({
  type: types.GET_UDHYAM_CATEGORY_SUCCESS,
  payload: { category }
});

export const getUdhyamCategoryFailure = (error) => ({
  type: types.GET_UDHYAM_CATEGORY_FAILURE,
  payload: { error }
});

// Create Udhyam Category
export const createUdhyamCategoryRequest = (categoryData) => ({
  type: types.CREATE_UDHYAM_CATEGORY_REQUEST,
  payload: { categoryData }
});

export const createUdhyamCategorySuccess = (category) => ({
  type: types.CREATE_UDHYAM_CATEGORY_SUCCESS,
  payload: { category }
});

export const createUdhyamCategoryFailure = (error) => ({
  type: types.CREATE_UDHYAM_CATEGORY_FAILURE,
  payload: { error }
});

// Update Udhyam Category
export const updateUdhyamCategoryRequest = (id, categoryData) => ({
  type: types.UPDATE_UDHYAM_CATEGORY_REQUEST,
  payload: { id, categoryData }
});

export const updateUdhyamCategorySuccess = (category) => ({
  type: types.UPDATE_UDHYAM_CATEGORY_SUCCESS,
  payload: { category }
});

export const updateUdhyamCategoryFailure = (error) => ({
  type: types.UPDATE_UDHYAM_CATEGORY_FAILURE,
  payload: { error }
});

// Set Editing Category
export const setUdhyamCategoryEditing = (category) => ({
  type: types.SET_UDHYAM_CATEGORY_EDITING,
  payload: { category }
});

// Clear Editing Category
export const clearUdhyamCategoryEditing = () => ({
  type: types.CLEAR_UDHYAM_CATEGORY_EDITING
});